import { render, staticRenderFns } from "./PoolIcon.vue?vue&type=template&id=70463478&scoped=true"
import script from "./PoolIcon.vue?vue&type=script&lang=js"
export * from "./PoolIcon.vue?vue&type=script&lang=js"
import style0 from "./PoolIcon.vue?vue&type=style&index=0&id=70463478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70463478",
  null
  
)

export default component.exports